function get_next_video(published_date, videovertical) {

    $.ajax({
        url: '/api/fe/get-next-video/',
        type: 'GET',
        data: {published: published_date, videovertical: videovertical},
        success: function (response) {
            if (response.status === 'error') {
                console.log(response.message);
            } else {
                var isYoutube = $($.parseHTML(response)).filter("#ytplayer");

                if (isYoutube.length) {
                    $('.embed-container').html(response).promise().done(function () {
                        hpYoutube.apiReady().then(function () {
                            // youtubeplayer is a global variable coming from youtube.js
                            youtubeplayer = new YT.Player('ytplayer', {
                                events: {
                                    'onStateChange': onYoutubePlayerStateChangeVideoEntry
                                }
                            });
                        });
                    });
                } else {
                    $('.embed-container').html(response);

                    //Check if it's a daily motion provider to setup the SDK.
                    hpDailyMotion.videoEntryAttach();
                }
            }
        }
    });
}
